<label class="subHeading">Vehicle Sub Type <span *ngIf="required" style="color: red;">*</span></label>
<app-search-dropdown
[dataSearchKey]="'name'"
[dataValueKey]="'value'"
[dataSource]="subTypes"
[control]="control"
[toolTipType]="'items'"
></app-search-dropdown>